import {RouteRecordRaw} from 'vue-router';

const maintenanceRoute = {
  path: '/',
  component: () => import('@/pages/Maintenance.vue')
};

const routes: RouteRecordRaw[] = [
  //maintenanceRoute, // MEMO: メンテナンス中はここをアンコメントする
  {
    path: '/',
    component: () => import('@/layouts/MainLayoutSimpleNarrow.vue'),
    children: [
      {path: '/', name: 'home', component: () => import('@projectRoot/pages/Home.vue'), meta: {requiresAuth: false}},
      {path: '/entry/:competition', name: 'app', component: () => import('@projectRoot/pages/Home.vue'), meta: {requiresAuth: false}, props: true},

      {path: 'announce', name: 'announce', component: () => import('@projectRoot/components/Announce.vue'), meta: {requiresAuth: false}},
      {path: 'expired', name: 'expired', component: () => import('@projectRoot/components/Expired.vue'), meta: {requiresAuth: false}},
      {path: 'preinit', name: 'preinit', component: () => import('@projectRoot/components/PreInitiation.vue'), meta: {requiresAuth: false}},
      {path: 'legalnotice', name: 'legalnotice', component: () => import('@projectRoot/pages/LegalNotice.vue'), meta: {requiresAuth: false}},
      {path: 'termsofuse', name: 'termsofuse', component: () => import('@projectRoot/pages/TermsOfUse.vue'), meta: {requiresAuth: false}},
    ]
  },
];

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '/:pathMatch(.*)*\'',
    component: () => import('@/pages/Error404.vue')
  });
}

export default routes;
